import React from 'react';
import { Countdown } from './Countdown';
import { PlanSelector } from './PlanSelector';
export function FinalOffer() {
  return <section aria-labelledby="final-title" className="mx-auto max-w-5xl px-4 py-12 md:px-5 md:py-20" data-id="element-90" data-mp="12i732908rrg0">
      <div className="mx-auto flex max-w-xl flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-91" data-mp="1ghyogut38a41">
        <div data-id="element-92" data-mp="1ch6c3sox5p3j">
          <h2 id="final-title" className="font-display text-2xl font-bold leading-tight text-bone md:text-3xl" data-id="element-93" data-mp="1qebixuwgirzu">No dejes pasar esta oportunidad</h2>
          <p className="mt-0.5 text-sm text-mist" data-id="element-94" data-mp="1leyux6tunevo">Termina en</p>
        </div>
        <Countdown variant="compact" data-id="element-95" data-mp="203cvtc7pgt9l" />
      </div>
      <div className="mt-7" data-id="element-96" data-mp="2067gn4umsg3j">
        <PlanSelector groupName="plan-final" data-id="element-97" data-mp="1v4rv7bojk7km" />
      </div>
    </section>;
}